import fp from 'lodash/fp';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './ActionButton.module.scss';

const ActionButton = (props) => {
    const typeStyles = useMemo(
        () => {
            if (props.neutral) return props.styles.neutral;
            if (props.active) return props.styles.active;
            if (props.accent) return props.styles.accent;
            if (props.negative) return props.styles.negative;
            if (props.positive) return props.styles.positive;
            return props.styles.primary;
        },
        [
            props.neutral,
            props.active,
            props.accent,
            props.negative,
            props.positive,
            props.styles
        ]
    );

    return (
        <button
            type="button"
            className={ classnames({
                [props.styles['action-button']]: true,
                [props.className]: true,
                [typeStyles]: true
            }) }
            onClick={ props.disabled ? fp.noop : props.onClick }
            disabled={ props.disabled }
        >
            { props.children }
        </button>
    );
};
ActionButton.propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    neutral: PropTypes.bool,
    active: PropTypes.bool,
    accent: PropTypes.bool,
    negative: PropTypes.bool,
    positive: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

ActionButton.defaultProps = {
    className: '',
    neutral: false,
    active: false,
    accent: false,
    negative: false,
    positive: false,
    disabled: false,
    styles
};

export default ActionButton;
